import React from 'react'

const TextInput = ({ type, name, placeholder, value, extraClasses, borderColor, backColor, borderRadius, onChange, disabled, readOnly,onBlur }) => {
    return (
        <input type={type} name={name} className={"form-control form-control-lg " + extraClasses + ' ' + borderColor + ' ' + backColor + ' ' + borderRadius}
            placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} disabled={disabled} readOnly={readOnly} />
    )
}

export default TextInput